import React, { useState } from "react";
import * as BosIdentityServices from "data/BosWebServices/BosIdentityServices";
import LoginHeader from "./LoginHeader";
import { getTranslation as translate } from "logic/LocaleManager";

import { LOGINTYPE_RESET_PASSWORD } from "../../pages/Login/LoginPage";

// DevExtreme components
import TextBox from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator, { RequiredRule } from 'devextreme-react/validator';
import Button from 'devextreme-react/button';

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as bosUserActions from "../../redux/actions/bosUserActions";

function ResetPassword(props) {
  const { actionSuccessfull, actionError, cleanMessages, setIsLoading, isLoading } = props;
  const resetFailedText = translate("resetPassword.failed", "Password reset failed!");
  const resetSuccessText = translate("resetPassword.success", "An Email has been send to: ");

  const [username, setUsername] = useState("");

  const loginChanged = e => {
    setUsername(e.value);
    cleanMessages();
  };

  async function reset(args) {
    if (!args.validationGroup.validate().isValid) return;
    await resetInternal(username);
    args.validationGroup.reset();
  }

  async function resetInternal(usr) {
    try {
      setIsLoading(true);
      let result = await BosIdentityServices.fetchResetPassword(usr);
      if (result) throw new Error(result);
      actionSuccessfull(LOGINTYPE_RESET_PASSWORD, null, resetSuccessText + usr);
      setIsLoading(false);
    } catch (error) {
      actionError(resetFailedText + " (" + error + ")");
      setIsLoading(false);
    }
  }

  return (
    <ValidationGroup>
      <LoginHeader title={translate("resetPassword.title", "Reset Password")} description={translate("resetPassword.description", "Reset your password with your email address")} />
      <div className={'dx-field'}>
        <TextBox
          value={username}
          onValueChanged={loginChanged}
          placeholder={translate("resetPassword.textBoxEmailLabel", "Email")}
          disabled={isLoading}
          width={'100%'}
        >
          <Validator>
            <RequiredRule message={translate("resetPassword.textBoxEmailError", "Email is required")} />
          </Validator>
        </TextBox>
      </div>
      <div className={'dx-field'}>
        <Button
          type={'default'}
          text={translate("resetPassword.action", "Reset")}
          onClick={reset}
          disabled={isLoading}
          width={'100%'}
        />
      </div>
    </ValidationGroup>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    bosUserActions: bindActionCreators(bosUserActions, dispatch)
  };
}

export default connect(
  null,
  mapDispatchToProps
)(ResetPassword);
